import callApi from 'lib/callApi';

// const to hold/cache the release notes date
let loadTimeReleaseNoteDate = null;

export async function loadLastReleaseNotesDate() {
  if (loadTimeReleaseNoteDate == null) {
    // get the last release notes date
    let url = 'release_notes/latest_date';

    try {
      await callApi(url, 'GET', {}).then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            loadTimeReleaseNoteDate = new Date(res.data.last_date);
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  }
  return loadTimeReleaseNoteDate;
}

export function getReleaseNotesLabel() {
  let releaseNoteLabel = 'Release Notes';

  let lastReleaseNotesDate = localStorage.getItem('releaseNoteLastReleaseDate');
  if (lastReleaseNotesDate)
    lastReleaseNotesDate = new Date(lastReleaseNotesDate);

  let lastVisitedDate = localStorage.getItem('releaseNoteLastVisitedDate');
  if (lastVisitedDate) lastVisitedDate = new Date(parseInt(lastVisitedDate));

  // console.log("Release notes label updating", releaseNoteLabel, lastReleaseNotesDate, lastVisitedDate);
  if (
    lastVisitedDate == null ||
    (lastReleaseNotesDate &&
      lastVisitedDate &&
      lastVisitedDate < lastReleaseNotesDate)
  ) {
    releaseNoteLabel = 'Release Notes 🔔';
    //   console.log("Release notes label updated to: ", releaseNoteLabel);
  }
  return releaseNoteLabel;
}
